module.exports = __webpack_public_path__ + "img/ya_game_backToTop.e9b4df08.png";